import { Redirect, Stack } from 'expo-router';
import { View } from 'react-native';

import { LocalCacheGate } from '@/components/domain/LocalCacheGate';
import { SessionErrorScreen } from '@/components/domain/SessionErrorScreen';
import { useAuth } from '@/lib/auth';

export default function AppLayout() {
  const { session, status, retry, signOut } = useAuth();

  // Before the signed-out redirect below, and deliberately: the session is UNKNOWN here, not
  // absent, and redirecting to /landing would report it as a sign-out (see `AuthStatus`).
  if (status === 'error') {
    return <SessionErrorScreen onRetry={retry} onSignOut={signOut} />;
  }

  // Allowlist, matching the PowerSync gate: only a KNOWN session reaches the redirect.
  if (status !== 'ready') {
    return <View className="flex-1 items-center justify-center bg-background"></View>;
  }

  // Single auth gate for every screen in this group.
  if (!session) {
    return <Redirect href="/landing" />;
  }

  // Screens render their own NavBar; no native headers.
  return (
    <LocalCacheGate>
      <Stack screenOptions={{ headerShown: false }} />
    </LocalCacheGate>
  );
}
